import { useEffect, useState } from "react";
import {
  Alert,
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { formatarCnpj } from "../../Apuracoes/utils";
import { formatarMoeda } from "../../Apuracoes/Detalhe/utils/agregarPorConta.util";
import { formatarData } from "../utils/projeto.util";
import styles from "../../Apuracoes/styles.module.css";

const NOVO = "novo";

/**
 * TXM-558 — "Salvar Projeto": confirma o que entra no projeto e, havendo projeto Em Prévia do
 * cliente, deixa sobrescrever em vez de criar outro. O valor aqui é uma prévia; o backend recalcula.
 */
export default function ModalSalvarProjeto({
  open,
  onClose,
  empresa,
  periodoLabel,
  selecao,
  projetosEmPrevia = [],
  salvando = false,
  onConfirmar,
}) {
  const [destino, setDestino] = useState(NOVO);

  useEffect(() => {
    if (open) setDestino(NOVO);
  }, [open]);

  const semItens = !selecao || selecao.itens === 0;

  const opcoesDestino = [
    { value: NOVO, label: "+ Criar novo projeto" },
    ...projetosEmPrevia.map((projeto) => ({
      value: String(projeto.idProjeto),
      label: `Sobrescrever ${projeto.codigo} (Em Prévia · criado em ${formatarData(projeto.dtCriacao)})`,
    })),
  ];

  const handleConfirmar = () => {
    onConfirmar?.({ sobrescreverIdProjeto: destino === NOVO ? null : Number(destino) });
  };

  return (
    <Dialog open={open} onClose={salvando ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <div className={styles.title}>
          <SaveOutlinedIcon sx={{ marginRight: ".5rem" }} />
          Salvar Projeto
        </div>
      </DialogTitle>
      <DialogContent className={styles.content}>
        <div className={styles.readonlyBlock}>
          <span className={styles.readonlyLabel}>Empresa</span>
          <Typography className={styles.readonlyValue}>{empresa?.razaoSocial || "—"}</Typography>
        </div>
        <div className={styles.readonlyBlock}>
          <span className={styles.readonlyLabel}>CNPJ</span>
          <Typography className={styles.readonlyValue}>{formatarCnpj(empresa?.cnpj)}</Typography>
        </div>
        <div className={styles.readonlyBlock}>
          <span className={styles.readonlyLabel}>Período do filtro</span>
          <Typography className={styles.readonlyValue}>{periodoLabel || "—"}</Typography>
        </div>
        <div className={styles.readonlyBlock}>
          <span className={styles.readonlyLabel}>Valor do resultado</span>
          <Typography className={styles.readonlyValue}>
            {formatarMoeda(selecao?.valorTotal ?? 0)}
          </Typography>
        </div>

        {semItens ? (
          <Alert severity="warning" sx={{ width: "100%" }}>
            Nenhuma linha do resultado filtrado compõe projeto (sem base legal).
          </Alert>
        ) : (
          <Alert severity="info" sx={{ width: "100%" }}>
            {selecao.itens} {selecao.itens === 1 ? "item entra" : "itens entram"} no projeto. Linhas
            sem base legal ou já utilizadas em outro projeto aprovado ficam de fora.
          </Alert>
        )}

        {projetosEmPrevia.length > 0 && (
          <div className={styles.field}>
            <Autocomplete
              fullWidth
              size="small"
              disableClearable
              options={opcoesDestino}
              value={opcoesDestino.find((o) => o.value === destino) ?? opcoesDestino[0]}
              onChange={(_, opt) => setDestino(opt.value)}
              getOptionLabel={(o) => o?.label ?? ""}
              isOptionEqualToValue={(a, b) => a?.value === b?.value}
              disabled={salvando}
              renderInput={(params) => <TextField {...params} id="salvar-projeto-destino" label="Salvar como" />}
            />
          </div>
        )}
      </DialogContent>

      <DialogActions className={styles.containerBtn}>
        <Button
          onClick={onClose}
          variant="contained"
          className={styles.btnCancelar}
          disabled={salvando}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleConfirmar}
          variant="contained"
          className={styles.btnSalvar}
          disabled={salvando || semItens}
        >
          {salvando ? "Salvando…" : "Salvar Projeto"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
